// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__9_Kpb","right":"Footer_right__x8pCQ","buttons":"Footer_buttons__RQdfh"};